import {
    exportarHelper,
    useBuscarHelper
} from "../../../Commons/Scripts/Utils/webservice-helper.js";
import {URL_EXPORTAR_TIENDA_DATAGRID} from "../../../Facturacion/Scripts/Utils/constantes"; 

const URL_BUSCAR_TARJETAS_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarDashboardTarjetas";
const URL_BUSCAR_GRAFICO_TOTAL_AUSENCIAS_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTotalAusenciasDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_PERMISOS_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTotalPermisosDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_LICENCIAS_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTotalLicenciasDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_PRESTAMOS_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTotalPrestamosDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_COSTO_HORAS_EXTRA_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoCostoHorasExtraDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_TASA_HORAS_EXTRA_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTasaHorasExtraDashboard";
const URL_BUSCAR_GRAFICO_TOTAL_HORAS_EXTRA_DASHBOARD = "/Nomina/WebService/NominaWebService.asmx/BuscarGraficoTotalHorasExtraDashboard";

const URL_BUSCAR_GRID_DEPARTAMENTOS_DASHBOARD = "/Nomina/WebService/DepartamentoWebService.asmx/BuscarDepartamentoRRHHGridDashboard";
const URL_BUSCAR_DEPARTAMENTOS_AUTOCOMPLETE = "/Nomina/WebService/DepartamentoWebService.asmx/BuscarListadoDepartamentos";

const URL_BUSCAR_GRID_EMPLEADOS_DASHBOARD = "/Nomina/WebService/EmpleadoWebService.asmx/BuscarEmpleadoRRHHGridDashboard";
const URL_BUSCAR_EMPLEADOS_AUTOCOMPLETE = "/Nomina/WebService/EmpleadoWebService.asmx/BuscarListadoEmpleados";

const URL_EXPORTAR_EMPLEADOS_GRID = "/Nomina/WebService/EmpleadoWebService.asmx/ExportarEmpleadoRRHHGrid";
const URL_EXPORTAR_DEPARTAMENTOS_GRID = "/Nomina/WebService/DepartamentoWebService.asmx/ExportarDepartamentoRRHHGrid";

export const useObtenerGraficoTotalHorasExtraDashboard = (cuerpo) => {
  const url = URL_BUSCAR_GRAFICO_TOTAL_HORAS_EXTRA_DASHBOARD;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}

export const useObtenerGridEmpleadosRRHHDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRID_EMPLEADOS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useBuscarEmpleadosAutoComplete = (cuerpo) => {
    const url = URL_BUSCAR_EMPLEADOS_AUTOCOMPLETE;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }


export const useObtenerGridDepartamentosRRHHDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRID_DEPARTAMENTOS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useBuscarDepartamentosAutoComplete = (cuerpo) => {
    const url = URL_BUSCAR_DEPARTAMENTOS_AUTOCOMPLETE;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }


export const useBuscarTarjetasDashboard = (cuerpo) => {
  const url = URL_BUSCAR_TARJETAS_DASHBOARD;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};   
}

export const useObtenerGraficoTotalAusenciasDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_AUSENCIAS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useObtenerGraficoTotalPermisosDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_PERMISOS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useObtenerGraficoTotalLicenciasDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_LICENCIAS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useObtenerGraficoTotalPrestamosDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_PRESTAMOS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useObtenerGraficoCostoHorasExtraDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_COSTO_HORAS_EXTRA_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useObtenerGraficoTasaHorasExtraDashboard = (cuerpo) => {
    const url = URL_BUSCAR_GRAFICO_TOTAL_TASA_HORAS_EXTRA_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

export const exportarEmpleadosGrid = async (cuerpo) => {

    try {
        await exportarHelper(URL_EXPORTAR_EMPLEADOS_GRID, cuerpo);
    } catch (error) {
        console.error("Falló la descarga del reporte:", error);
        alert("Ocurrió un error al generar el reporte. Por favor, intente de nuevo.");
    } finally {
        // Oculta el indicador de carga
        // document.getElementById('spinner').style.display = 'none';
    }
}

export const exportarDepartamentosGrid = async (cuerpo) => {

    try {
        await exportarHelper(URL_EXPORTAR_DEPARTAMENTOS_GRID, cuerpo);
    } catch (error) {
        console.error("Falló la descarga del reporte:", error);
        alert("Ocurrió un error al generar el reporte. Por favor, intente de nuevo.");
    } finally {
        // Oculta el indicador de carga
        // document.getElementById('spinner').style.display = 'none';
    }
}